import type { EntryValueViewT } from "@patient-watch/types";
import { cn } from "@/lib/utils";
import { isCheckboxTicked } from "../../checkboxRuns";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface CheckboxGroupEntryValueProps extends Omit<BaseEntryValueProps, "inputLabel" | "children"> {
    entryValues: EntryValueViewT[];
}

/** One multi-select list: shows only the ticked options as a plain vertical list. The page heading names the question. */
export function CheckboxGroupEntryValue({ entryValues, size, className, ...props }: CheckboxGroupEntryValueProps) {
    const ticked = entryValues.filter(isCheckboxTicked);

    return (
        <BaseEntryValue size={size} className={className} {...props}>
            {ticked.length > 0 ? (
                <ul
                    className={cn(
                        "flex flex-col gap-1 text-slate-900 dark:text-slate-200",
                        size === "sm" ? "text-sm" : "text-base"
                    )}
                >
                    {ticked.map((ev) => (
                        <li key={ev.entry_value_id}>{ev.input_label}</li>
                    ))}
                </ul>
            ) : (
                <span className={cn("text-slate-900 dark:text-slate-200", size === "sm" ? "text-sm" : "text-base")}>
                    None selected
                </span>
            )}
        </BaseEntryValue>
    );
}
